import initialState from '~/store/initialState';
import {
  ADD_EMPTY_OWNER_PLACEHOLDER,
  OfferAction,
  REMOVE_OWNER_PLACEHOLDER,
  SET_ACCESS_TOKEN_ERROR,
  SET_HAS_OFFER,
  SET_OFFER_DATA,
  SET_OFFER_IS_AGREED,
  SET_OFFER_SUBMIT_STATUS,
  SET_PERSONAL_LIABILITY_IS_AGREED,
  SET_REGULAR_MAIL_FOR_INVOICES,
  UPDATE_OFFER_DATA,
  UPDATE_OFFER_SIGNERS,
  UPDATE_OWNER,
  UPDATE_YOUR_OWN_SHARES,
} from '~/store/types/loanOfferTypes';
import { generateOwnerPlaceholder } from '~/helpers/generators.helper';
import { LoanOwner, Offer, OfferUserData } from '~/Interfaces';
import { Signer } from '~/types/types';

interface OfferState {
  readonly overview: Offer[];
  readonly userData: OfferUserData;
  readonly hasOffer: boolean;
  readonly isSubmitting: boolean;
  readonly hasAccessTokenError: boolean;
}

const loanOfferReducer = (
  state = initialState.loanOffer,
  action: OfferAction
): OfferState => {
  switch (action.type) {
    case SET_OFFER_DATA:
      return {
        ...state,
        overview: action.payload,
      };

    case SET_HAS_OFFER:
      return { ...state, hasOffer: action.payload };

    case UPDATE_YOUR_OWN_SHARES:
      return {
        ...state,
        userData: {
          ...state.userData,
          yourOwnShares: action.payload,
        },
      };

    case UPDATE_OFFER_DATA:
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.payload,
        },
      };

    case ADD_EMPTY_OWNER_PLACEHOLDER:
      return {
        ...state,
        userData: {
          ...state.userData,
          owners: [...state.userData.owners, generateOwnerPlaceholder()],
        },
      };

    case REMOVE_OWNER_PLACEHOLDER:
      return {
        ...state,
        userData: {
          ...state.userData,
          owners: state.userData.owners.filter(
            (owner: LoanOwner) => owner.id !== action.payload
          ),
        },
      };

    case UPDATE_OWNER:
      return {
        ...state,
        userData: {
          ...state.userData,
          owners: state.userData.owners.map((owner: LoanOwner) => {
            if (owner.id === action.payload.id) {
              return action.payload;
            }
            return owner;
          }),
        },
      };

    case UPDATE_OFFER_SIGNERS:
      return {
        ...state,
        userData: {
          ...state.userData,
          signers: state.userData.signers.map((signer: Signer) => {
            if (signer.signer_id === action.payload.signer_id) {
              return { ...signer, ...action.payload };
            }
            return signer;
          }),
        },
      };

    case SET_OFFER_IS_AGREED:
      return {
        ...state,
        userData: {
          ...state.userData,
          offerIsAgreed: action.payload,
        },
      };

    case SET_PERSONAL_LIABILITY_IS_AGREED:
      return {
        ...state,
        userData: {
          ...state.userData,
          personalLiabilityIsAgreed: action.payload,
        },
      };

    case SET_REGULAR_MAIL_FOR_INVOICES:
      return {
        ...state,
        userData: {
          ...state.userData,
          regularMailForInvoices: action.payload,
        },
      };

    case SET_OFFER_SUBMIT_STATUS:
      return { ...state, isSubmitting: action.payload };

    case SET_ACCESS_TOKEN_ERROR:
      return { ...state, hasAccessTokenError: action.payload };

    default:
      return state;
  }
};

export default loanOfferReducer;
